"use client";

import { Card, CardContent } from "@/shared/ui/cards/card";
import { Skeleton } from "@/shared/ui/data-display/skeleton";

export function OrganizationGridSkeleton() {
  return (
    <div className="flex-1 overflow-hidden px-0">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 pb-16 pt-0">
        {Array.from({ length: 6 }).map((_, index) => (
          <Card
            key={index}
            className="group flex h-full flex-col gap-0 p-0 overflow-hidden border border-border/60 bg-card/70"
          >
            {/* Banner Skeleton */}
            <div className="w-full relative overflow-hidden bg-muted aspect-[3/1]">
              <Skeleton className="h-full w-full" />
            </div>

            {/* Content Skeleton */}
            <CardContent className="flex h-full flex-col gap-4 p-4 pt-5">
              <div className="flex-1 space-y-4">
                {/* Header: Name */}
                <div className="flex items-start justify-between gap-2">
                   <Skeleton className="h-6 w-3/4 rounded" />
                   <Skeleton className="h-5 w-5 rounded-full" />
                </div>

                {/* Description */}
                <div className="space-y-2">
                  <Skeleton className="h-3 w-full" />
                  <Skeleton className="h-3 w-5/6" />
                  <Skeleton className="h-3 w-4/6" />
                </div>

                {/* Stats Grid */}
                <div className="grid grid-cols-3 gap-2">
                  <Skeleton className="h-16 w-full rounded-lg" />
                  <Skeleton className="h-16 w-full rounded-lg" />
                  <Skeleton className="h-16 w-full rounded-lg" />
                </div>
              </div>

              {/* Tournament Skeleton */}
              <div className="px-0 pb-2">
                  <div className="p-3 rounded border-l-2 border-muted bg-muted/20">
                    <Skeleton className="h-3 w-24 mb-2" />
                    <Skeleton className="h-4 w-40 mb-1" />
                    <Skeleton className="h-3 w-16" />
                  </div>
              </div>

              {/* Button Skeleton */}
              <div className="mt-auto pt-2">
                <Skeleton className="h-9 w-full rounded" />
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
